<mat-expansion-panel class="mat-elevation-z0">
    <mat-expansion-panel-header>
        <mat-panel-title class="bold">
            {{ 'common.labels.filters' | transloco }}
        </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="_filterForm" class="padding">
        <div class="flex-container">
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
                <input matInput [formControlName]="'businessName'" [placeholder]="'common.labels.businessName' | transloco" />
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.businessNumber' | transloco }}</mat-label>
                <input matInput [formControlName]="'businessNumber'" [placeholder]="'common.labels.businessNumber' | transloco" />
            </mat-form-field>
        </div>

        <div class="flex-container">
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'hubReportsFilter.orderReference' | transloco }}</mat-label>
                <input matInput [formControlName]="'orderReference'" [placeholder]="'hubReportsFilter.orderReference' | transloco" />
            </mat-form-field>
        </div>

        <lib-jurisdiction-selection (formReady)="handleJurisdictionFormReady($event)" [defaultCountry]="'CA'"
            [multiSelect]="true" [includeFederal]="true"></lib-jurisdiction-selection>

        <div class="flex-container">
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'hubReportsFilter.lastUpdatedFrom' | transloco }}</mat-label>
                <input matInput [matDatepicker]="envelopeStatusUpdatedDateFrom"
                    [formControlName]="'envelopeStatusUpdatedDateFrom'" [placeholder]="'hubReportsFilter.lastUpdatedFrom' | transloco">
                <mat-datepicker-toggle matSuffix [for]="envelopeStatusUpdatedDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #envelopeStatusUpdatedDateFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'hubReportsFilter.lastUpdatedTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="envelopeStatusUpdatedDateTo"
                    [formControlName]="'envelopeStatusUpdatedDateTo'" [placeholder]="'common.labels.dateRequestedTo' | transloco">
                <mat-datepicker-toggle matSuffix [for]="envelopeStatusUpdatedDateTo"></mat-datepicker-toggle>
                <mat-datepicker #envelopeStatusUpdatedDateTo></mat-datepicker>
            </mat-form-field>
        </div>

        <div>
            <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
                (click)="onClear()" [disabled]="!_filterForm.dirty">
                {{ 'common.labels.clearFilters' | transloco }}
            </button>
            <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
                (click)="onFilter()">
                {{ 'common.labels.filter' | transloco }}
            </button>
        </div>
    </form>
</mat-expansion-panel>